/* Custom Product Cards: colour swatches.
   Works the same for both content sources: every swatch carries what selecting it changes
   (image key, colour name, link and, for Shopify products, price / compare-at / availability).
   Scoped per card, so several section instances can coexist. */
(function () {
  function initCard(card) {
    if (card.dataset.pcReady === 'true') return;
    card.dataset.pcReady = 'true';

    var swatches = Array.prototype.slice.call(card.querySelectorAll('[data-pc-swatch]'));
    if (!swatches.length) return;

    var images = Array.prototype.slice.call(card.querySelectorAll('.custom__pc-card-image'));
    var label = card.querySelector('[data-pc-label]');
    var link = card.querySelector('[data-pc-link]');
    var linkText = card.querySelector('[data-pc-btn-text]');
    var price = card.querySelector('[data-pc-price-text]');
    var compare = card.querySelector('[data-pc-compare-text]');
    var saleBadge = card.querySelector('[data-pc-badge="sale"]');
    var soldOutBadge = card.querySelector('[data-pc-badge="sold-out"]');

    var current = 0;
    swatches.forEach(function (swatch, i) {
      if (swatch.classList.contains('is-active')) current = i;
    });

    function select(index) {
      current = index;
      var active = swatches[current];

      swatches.forEach(function (swatch, i) {
        var on = i === current;
        swatch.classList.toggle('is-active', on);
        swatch.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      /* Never leave the card without a picture: only switch when the target layer exists. */
      var key = active.getAttribute('data-pc-image');
      var target = null;
      images.forEach(function (image) {
        if (key && image.getAttribute('data-pc-image') === key) target = image;
      });
      if (target) {
        images.forEach(function (image) {
          image.classList.toggle('is-active', image === target);
        });
      }

      /* Shopify product source: artwork from the variant metafield uses the block's image style,
         a variant / product photo always uses the product-photo style. */
      var fit = active.getAttribute('data-pc-fit');
      if (fit && target) card.classList.toggle('custom__pc-card--fit-card', fit === 'card');

      if (label) label.textContent = active.getAttribute('data-pc-name') || '';

      if (link) {
        var url = active.getAttribute('data-pc-url') || link.getAttribute('data-pc-default-url');
        if (url) {
          link.setAttribute('href', url);
        } else {
          link.removeAttribute('href');
        }
      }

      /* Shopify product source only */
      if (active.hasAttribute('data-pc-price')) {
        var comparePrice = active.getAttribute('data-pc-compare') || '';
        var available = active.getAttribute('data-pc-available') !== 'false';

        if (price) price.textContent = active.getAttribute('data-pc-price');
        if (compare) {
          compare.textContent = comparePrice;
          compare.hidden = !comparePrice;
        }
        if (saleBadge) saleBadge.hidden = !comparePrice;
        if (soldOutBadge) soldOutBadge.hidden = available;
        if (link) {
          link.classList.toggle('is-sold-out', !available);
          if (linkText && link.hasAttribute('data-pc-btn-label')) {
            linkText.textContent = available
              ? link.getAttribute('data-pc-btn-label')
              : link.getAttribute('data-pc-btn-label-sold-out');
          }
        }
      }
    }

    swatches.forEach(function (swatch, i) {
      swatch.addEventListener('click', function () {
        select(i);
      });
    });

  }

  function init(root) {
    var cards = (root || document).querySelectorAll('[data-pc-card]');
    Array.prototype.forEach.call(cards, initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  /* Theme editor */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var card = event.target;
    if (!card || !card.matches || !card.matches('[data-pc-card]')) return;
    initCard(card);
    if (card.scrollIntoView) card.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  });
})();
